export default __webpack_public_path__ + "static/media/mtg1.c47d658e.png";